import React from "react";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import {observer} from "mobx-react-lite";
import {useStores} from "../hooks/use-stores";
import {useTranslation} from "react-i18next";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import {makeStyles} from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";


const useStyles = makeStyles((theme) => ({
     root:{
         color: "white",
         padding:10
     },
    appbarToolbar: {
        height: 58
    },
    appLogo: {
        paddingLeft: theme.spacing(1),
        whiteSpace: "nowrap",

    },
    appLogoImg: {
        height: 27,
        width: 27,
    },
    appLogoText: {
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "35px",
        [theme.breakpoints.down('xs')]: {
            fontSize:  19,
        },
    },
}))


function ShoppingBossOnboarding()  {
    const classes = useStyles()
    const {onboardStore, authStore} = useStores()
    const {t} = useTranslation("onboard")
    const { sbSetupCompleted } = authStore;
    const {  savingSBData, savingSBDataError } = onboardStore;

    const handleAccountCreate = async () => {
        await onboardStore.saveSBData({});
    };

    if ( sbSetupCompleted )
        return  <Container maxWidth={"md"} className={classes.root}>
            <Grid container justifyContent={"center"} alignItems={"center"}>
                <Grid container item xs={12}>
                    <Typography variant={"subtitle2"}>{t("already_have")}</Typography>
                </Grid>
                <Grid container item xs={12} justifyContent={"center"} alignItems={"center"}>
                    <Button color={"secondary"} variant={"contained"} href={"/"}>{t("home")}</Button>
                </Grid>
            </Grid>

        </Container>



    return  <Container maxWidth={"md"} className={classes.root}>
             <Grid container justifyContent={"center"} alignItems={"center"}>
                 <Grid container item xs={12}>
                     <Toolbar disableGutters variant="dense" className={classes.appbarToolbar}>
                         <span className={classes.appLogo}>
                        <img src={"/logo.png"} className={classes.appLogoImg} />
                        <span className={classes.appLogoText}>Life - National Brand Stores Setup</span>
                    </span>
                     </Toolbar>
                 </Grid>
                 <Grid container item spacing={4}>
                     <Grid container item xs={12}>
                         <Typography variant={"h6"}>{t("welcome")}</Typography>
                     </Grid>
                     <Grid container item xs={12}>
                         <Typography variant={"subtitle2"}>{t("first_time")}</Typography>
                     </Grid>
                     {savingSBDataError && <Grid container item xs={12}>
                         <Alert severity="error">{savingSBDataError}</Alert>
                     </Grid>}
                     <Grid  item xs={12}>
                         <Divider/>
                     </Grid>
                     <Grid container item xs={12} justifyContent={"center"} alignItems={"center"}>
                         <Button
                             color={"secondary"}
                             variant={"contained"}
                             onClick={handleAccountCreate}
                             disabled={savingSBData}
                             startIcon={savingSBData ? <CircularProgress size={18} color="inherit" /> : null}
                         >
                             {t("create_new_account")}
                         </Button>
                    </Grid>
                     <Grid  item xs={12}>
                         <Divider/>
                     </Grid>
                     <Grid container item xs={12}>
                         <Typography variant={"subtitle2"}>{t("already_have_support")}</Typography>
                     </Grid>
                 </Grid>
             </Grid>
        </Container>

}

export default observer( ShoppingBossOnboarding )
